import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BgColorOptions, ColorOptions, HorizontalAlignmentOptions, TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export interface PageComponentMultiTabComponentData extends NICmsContentComponent.IData {
    tabs: PageComponentMultiTabItemComponentData[];
    title?: string;
    title_style?: string;
    title_align?: number;
    title_color?: string;
    text?: string;
}

export interface PageComponentMultiTabItemComponentData {
    text: string;
    text_color?: string;
    text_style?: string;
    tab_bg_color?: string;
    additional_text?: string;
}

@ICmsComponent<PageComponentMultiTabComponent>({
    id: 'multi-tab',
    name: 'Multi Tab',
    tags: ['Homepage', 'Multi', 'Tab'],
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title',
            default: 'Lorem ipsum'
        },
        <NICmsContentField.IChoiceField>{
            key: 'title_style',
            type: NICmsContentField.EFieldType.choice,
            title: 'Title Style',
            options: TextStyleOptions,
            default: 'h1'
        },
        <NICmsContentField.IChoiceField>{
            key: 'title_align',
            type: NICmsContentField.EFieldType.choice,
            title: 'Title Alignment',
            options: HorizontalAlignmentOptions,
            default: 'center'
        },
        <NICmsContentField.IChoiceField>{
            key: 'title_color',
            type: NICmsContentField.EFieldType.choice,
            title: 'Title Color',
            options: ColorOptions,
            colorPreview: true,
            default: 'col-b'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'tabs',
            title: 'Tabs',
            itemName: 'Tab',
            maxSize: 4,
            defaultSize: 4,
            fields: [
                <NICmsContentField.IChoiceField>{
                    key: 'tab_bg_color',
                    type: NICmsContentField.EFieldType.choice,
                    colorPreview: true,
                    title: 'Tab Background Color',
                    options: BgColorOptions,
                    default: 'bg-col-w'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'text',
                    title: 'Text',
                    required: true,
                    default: 'Lorem ipsum'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'text_style',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Text Style',
                    options: TextStyleOptions,
                    default: 'h1'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'text_color',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Text Color',
                    options: ColorOptions,
                    colorPreview: true,
                    default: 'col-b'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'additional_text',
                    title: 'Additional text',
                    default: 'Lorem ipsum'
                }
            ]
        }
    ]
})
@Component({
    selector: 'page-component-multi-tab',
    templateUrl: './multi-tab.html',
    standalone: true,
    imports: [ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponentMultiTabComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: PageComponentMultiTabComponentData;
}
